module.exports = __webpack_public_path__ + "static/media/insta_icon.197730ec.svg";